import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import type { PaySchedule } from '@/types';
import { APP_TIMEZONE, DEFAULT_PAY_SCHEDULE, todayIsoReportMonth } from '@/utils';

export const usePayPeriodSelection = (paySchedule: PaySchedule = DEFAULT_PAY_SCHEDULE) => {
  const [currentPeriodMonth, setCurrentPeriodMonth] = useState(() =>
    todayIsoReportMonth(paySchedule),
  );
  const [periodMonth, setPeriodMonth] = useState(() => todayIsoReportMonth(paySchedule));
  const previousCurrentPeriodMonth = useRef(currentPeriodMonth);

  useEffect(() => {
    setCurrentPeriodMonth(todayIsoReportMonth(paySchedule));
  }, [paySchedule]);

  useEffect(() => {
    const previousCurrent = previousCurrentPeriodMonth.current;
    setPeriodMonth((selectedPeriod) =>
      selectedPeriod === previousCurrent ? currentPeriodMonth : selectedPeriod,
    );
    previousCurrentPeriodMonth.current = currentPeriodMonth;
  }, [currentPeriodMonth]);

  useEffect(() => {
    let timeout: number;
    const scheduleUpdate = () => {
      const now = dayjs().tz(APP_TIMEZONE);
      const nextBoundary =
        paySchedule === 'calendar-month'
          ? now.add(1, 'month').startOf('month')
          : (now.date() >= 21 ? now.add(1, 'month') : now).date(21).startOf('day');
      timeout = window.setTimeout(
        () => {
          setCurrentPeriodMonth(todayIsoReportMonth(paySchedule));
          scheduleUpdate();
        },
        Math.min(nextBoundary.diff(now), 2_147_000_000),
      );
    };

    scheduleUpdate();
    return () => window.clearTimeout(timeout);
  }, [paySchedule]);

  return { currentPeriodMonth, periodMonth, setPeriodMonth };
};
